import type {
  SortDirection,
  SortOption,
} from "@client/hooks/use-my-evaluations-data";
import { Checkbox, TableHead, TableHeader, TableRow } from "@sfc/ui";
import { SortableTableHead } from "./tables/sortable-table-head";
import { getProposalColumnClass } from "./proposals-table-layout";

export function ProposalsTableHeader({
  isRecommender,
  isObserver = false,
  sort,
  sortDirection,
  onSortChange,
  canHide = false,
  allEligibleSelected = false,
  onToggleSelectAll,
  searchActive = false,
  showTracks = true,
}: {
  isRecommender: boolean;
  isObserver?: boolean;
  sort: SortOption;
  sortDirection: SortDirection;
  onSortChange: (sort: SortOption) => void;
  canHide?: boolean;
  allEligibleSelected?: boolean;
  onToggleSelectAll?: () => void;
  searchActive?: boolean;
  // Trackless rounds hide the Tracks column entirely.
  showTracks?: boolean;
}) {
  const proposalColumnClass = getProposalColumnClass({
    searchActive,
    isRecommender,
  });

  return (
    <TableHeader className="bg-surface-base">
      <TableRow className="border-border-subtle">
        {canHide && (
          <TableHead className="w-10 px-2 py-3">
            <Checkbox
              checked={allEligibleSelected}
              onCheckedChange={onToggleSelectAll}
              aria-label="Select all"
            />
          </TableHead>
        )}
        <SortableTableHead
          label="Proposal Name"
          sortKey="org-name"
          currentSort={sort}
          sortDirection={sortDirection}
          onSort={onSortChange}
          className={proposalColumnClass}
        />
        {showTracks && (
          <TableHead className="w-44 min-w-36 text-label-md font-medium text-text-secondary px-4 py-3">
            Tracks
          </TableHead>
        )}
        <SortableTableHead
          label="Base Request"
          sortKey="base-request"
          currentSort={sort}
          sortDirection={sortDirection}
          onSort={onSortChange}
          align="right"
          className="w-32 min-w-28"
        />
        {isObserver && (
          <SortableTableHead
            label="Notes"
            sortKey="notes"
            currentSort={sort}
            sortDirection={sortDirection}
            onSort={onSortChange}
            align="center"
          />
        )}
        {isRecommender && (
          <SortableTableHead
            label="Investigation Interest"
            sortKey="investigation-interest"
            currentSort={sort}
            sortDirection={sortDirection}
            onSort={onSortChange}
            align="center"
          />
        )}
        {isRecommender && (
          <SortableTableHead
            label="Review Progress"
            sortKey="review-progress"
            currentSort={sort}
            sortDirection={sortDirection}
            onSort={onSortChange}
            align="center"
          />
        )}
        {isRecommender && (
          <SortableTableHead
            label="Status"
            sortKey="status"
            currentSort={sort}
            sortDirection={sortDirection}
            onSort={onSortChange}
            align="center"
          />
        )}
        {isRecommender && (
          <SortableTableHead
            label="Last Touched"
            sortKey="last-touched"
            currentSort={sort}
            sortDirection={sortDirection}
            onSort={onSortChange}
            align="right"
          />
        )}
        {isRecommender && (
          <TableHead
            className="w-10 px-2 py-3 text-label-md font-medium text-text-secondary"
            aria-label="Actions"
          />
        )}
      </TableRow>
    </TableHeader>
  );
}
